import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import BrandIntroSection from './components/BrandIntroSection';
import LatestBooks2026Section from './components/LatestBooks2026Section';
import TopicExplorationSection from './components/TopicExplorationSection';
import CooperationSection from './components/CooperationSection';
import HomeFAQSection from './components/HomeFAQSection';
import BottomCTASection from './components/BottomCTASection';

export default function Home() {
  return (
    <>
      <PageMeta
        title="財經錢線｜商業理財、心理學與以古諷今類書籍"
        description="財經錢線（FINELINE）以商業理財、心理學與以古諷今類書籍為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。"
      />
      <Navbar />
      <main>
        <HeroSection />
        <BrandIntroSection />
        <LatestBooks2026Section />
        <TopicExplorationSection />
        <CooperationSection />
        <HomeFAQSection />
        <BottomCTASection />
      </main>
      <Footer />
    </>
  );
}